<template>
  <div>
    <stripe-checkout
      ref="checkoutRef"
      :pk="publicKey"
      :items="stripeCheckoutItems"
      :successUrl="successUrl"
      :cancelUrl="cancelUrl"
      :locale="locale"
      :sessionId="sessionId"
      v-if="canBeDirectPayment"
    >
    </stripe-checkout>
    <button
      :class="
        `checkout-button ${
          disablePaymentButton || paymentStarted ? 'disabled mb-8' : 'mb-8'
        }`
      "
      :style="[
        { 'border-radius': buttonBorderRadiusTheme },
        { color: colorsGeneralPrimary },
        { borderColor: colorsGeneralPrimary }
      ]"
      :disabled="disablePaymentButton || paymentStarted"
      @click="startPayment"
    >
      <span>{{ $t("payment.pay") }}</span>
    </button>
  </div>
</template>
<script>
const NO_QR = "NO QR";
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import firebaseMixin from "@/mixins/firebase/firebaseMixin";
import paymentsMixin from "@/mixins/payment/paymentsMixin";
import formatMixin from "@/mixins/common/formatMixin";

import { updatePayment } from "@/collections/payments";

export default {
  name: "stripePayment",
  mixins: [firebaseMixin, paymentsMixin, formatMixin],
  props: [
    "totalPrice",
    "disablePaymentButton",
    "drinksCollection",
    "foodCollection",
    "dessertCollection",
    "cart",
    "selectedPaymentMethod",
    "canBeDirectPayment",
    "tableQR",
    "dividePayment"
  ],
  components: {
    StripeCheckout
  },
  data() {
    return {
      publicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      locale: "es",
      sessionId: null,
      paymentStarted: false
    };
  },
  computed: {
    successUrl() {
      return `${this.projectUrl}/success/{CHECKOUT_SESSION_ID}?qr=${this.tableQR}`;
    },
    cancelUrl() {
      return `${this.projectUrl}?qr=${this.tableQR}`;
    },
    stripeCheckoutItems() {
      let items = [];
      let self = this;
      const { drinks, food, dessert } = this.$store.state.productTypeIds;

      let _stripeItems = [...this.$store.state.stripeCheckoutItems];

      _stripeItems.forEach(_stripeItem => {
        // check for drinks
        if (_stripeItem.product_type_id === drinks) {
          let product = self.drinksCollection.find(
            d => d.id === _stripeItem.product_id
          );

          // if stock is greater then 0, prepare stripe item
          if (product && product.stock > 0) {
            items.push({
              sku: _stripeItem.sku,
              quantity: _stripeItem.quantity
            });
          }
        }

        // check for food
        if (_stripeItem.product_type_id === food) {
          let product = self.foodCollection.find(
            f => f.id === _stripeItem.product_id
          );

          // if stock is greater then 0, prepare stripe item
          if (product && product.stock > 0) {
            items.push({
              sku: _stripeItem.sku,
              quantity: _stripeItem.quantity
            });
          }
        }

        // check for deserts
        if (_stripeItem.product_type_id === dessert) {
          let product = self.dessertCollection.find(
            f => f.id === _stripeItem.product_id
          );

          // if stock is greater then 0, prepare stripe item
          if (product && product.stock > 0) {
            items.push({
              sku: _stripeItem.sku,
              quantity: _stripeItem.quantity
            });
          }
        }
      });

      return items;
    },
    totalAmount() {
      const { cart } = this.$store.state;
      return cart.reduce((acc, item) => acc + item.quantity * item.price, 0);
    }
  },
  methods: {
    startPayment() {
      this.paymentStarted = true;
      if (!this.tableQR || this.tableQR === NO_QR) {
        this.checkQR = true;
        this.$emit("checkQRUpdate", this.checkQR);
        this.paymentStarted = false;
        return;
      }
      // check cart item length is greater then 20
      const { cart } = this.$store.state;
      if (cart.length > 20) {
        this.showErrorMessage(
          this.$t("common.theMaximumNumberOfProductAllowed")
        );
        this.paymentStarted = false;
        return;
      }

      this.checkoutDirect();
    },
    async checkoutDirect() {
      localStorage.setItem("lastLand", "checkout");

      try {
        let paymentId = await this.initPayment({
          orders: this.cart,
          paymentMethod: "stripe",
          amount: this.totalAmount,
          orderAmount: this.totalAmount,
          paymentType: "product"
        });
        if (
          this.selectedPaymentMethod &&
          this.selectedPaymentMethod.cardLast4 !== -1
        ) {
          // charge existing customer
          let response = await this.$api.stripe.chargeCustomer({
            amount: parseInt(this.totalPrice * 100),
            currency: "eur",
            customer: this.selectedPaymentMethod.customerId,
            payment_method: this.selectedPaymentMethod.paymentMethod,
            error_on_requires_action: true,
            confirm: true,
            metadata: {
              paymentId: paymentId
            }
          });
          updatePayment(paymentId, {
            externalPaymentId: response.id
          });
          this.$router.push({
            path: "/success/_/?p_id=" + paymentId
          });
        } else {
          const session = await this.$api.stripe.createSession({
            mode: "payment",
            success_url: this.successUrl + "&p_id=" + paymentId,
            cancel_url: this.cancelUrl,
            locale: this.locale,
            line_items: this.stripeCheckoutItems.map(x => ({
              quantity: x.quantity,
              price: x.sku
            })),
            payment_method_types: ["card"],
            payment_intent_data: {
              setup_future_usage: "off_session",
              metadata: {
                paymentId: paymentId
              }
            }
          });
          this.sessionId = session.id;

          this.$refs.checkoutRef.redirectToCheckout();
        }
      } catch (error) {
        this.paymentStarted = false;

        this.setlogError(
          "stripe-payment",
          "Obtained error message",
          error.stack,
          this.$options.name
        );
      }
    }
  }
};
</script>
